"use client";

import React from "react";
import { Typography } from "@mui/material";

// Definindo o tipo de propriedades esperadas
interface TitleTypographyProps {
  variant: "h4" | "h5" | "h6"; // Tipagem para garantir que apenas tamanhos de título válidos sejam usados
  children: React.ReactNode;
  sx?: object; // Permite estilizar por fora do componente
  dataTestId?: string; // Optional for testing purposes
}

/**
 * Componente reutilizável para renderizar títulos principais
 * @param {string} variant O tamanho do título (h4, h5, h6).
 * @param {React.ReactNode} children O conteúdo do título.
 * @param {object} sx Estilo adicional, se necessário.
 * @param {string} dataTestId Para teste de componentes.
 */
const TitleTypography: React.FC<TitleTypographyProps> = ({
  variant,
  children,
  sx,
  dataTestId,
}) => {
  return (
    <Typography
      variant={variant}
      component="h1"
      sx={{
        textAlign: "center",
        fontWeight: 600,
        mb: 3,
        color: "text.primary",
        fontSize: "1.75rem",
        ...sx, // Adiciona estilos adicionais se fornecido
      }}
      data-testid={dataTestId}
    >
      {children}
    </Typography>
  );
};

export default TitleTypography;
